export enum TransportStatus {
  DRAFT = 'DRAFT',
  TO_START = 'TO_START',
  ON_GOING = 'ON_GOING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
